import moment from 'moment';
import { useMemo } from 'react';

import { NetSuiteContextType } from '../../../../reducers/page/netSuiteContextReducer';

export const useDiscountDateValue = (
    terms: NetSuiteContextType['terms'],
    selectedTermId: string | undefined,
    date?: string | null
) => {
    const selectedTerm = useMemo(() => terms.find((term) => term.id === selectedTermId), [terms, selectedTermId]);

    return useMemo(() => {
        if (!date || !selectedTerm) {
            return null;
        }

        const utcDate = moment.utc(date);

        return typeof selectedTerm?.daysUntilExpiry === 'number'
            ? moment(utcDate).add(selectedTerm.daysUntilExpiry, 'd').toISOString()
            : null;
    }, [selectedTerm, date]);
};
